export const ADDRESS_PROOF_THIRD_PARTY_TYPES = {
  mother_name: 'mother_name',
  father_name: 'father_name',
  spouse_name: 'spouse_name',
}

export const TRANSLATED_ADDRESS_PROOF_THIRD_PARTY_TYPES = {
  mother_name: 'Mãe',
  father_name: 'Pai',
  spouse_name: 'Cônjuge',
}

export const DEFAULT_ADDRESS_PROOF_THIRD_PARTY_TYPE = 'mother_name'
